<div *ngIf="partiesResponse" class="epds_mat_override parties-container">
  <div fxFill fxLayout="row wrap">
      <mat-card appearance="outlined" fxFlex="50">
        <mat-card-content class="mat-elevation-z8 no-bottom-pad" style="height: 100%" >
          <table aria-label="Table with first half of case information" role="presentation" style="width: 100%;">
            <colgroup>
              <col style="width: 30%;">
              <col style="width: 70%;">
            </colgroup>
            <tbody>
              <tr>
                <td><span><strong>Protester</strong></span></td>
                <td><span>{{ partiesResponse.protestInfo.company_Name }}</span></td>
              </tr>
              <tr>
                <td><span><strong>B-Number</strong></span></td>
                <td>
                  <span [ngClass]="{ 'pending-entry color_warn': !partiesResponse.protestInfo.b_No  }"
                        [matTooltip]="partiesResponse.protestInfo.a_No">
                    {{ partiesResponse.protestInfo.b_No || "pending" }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><span><strong>Agency</strong></span></td>
                <td><span>{{ partiesResponse.protestInfo.agency_Name }}</span></td>
              </tr>
              <tr>
                <td><span><strong>Solicitation Number</strong></span></td>
                <td><span>{{ partiesResponse.protestInfo.solicitation_No }}</span></td>
              </tr>
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" fxFlex="50">
        <mat-card-content class="mat-elevation-z8 no-bottom-pad" style="height: 100%">
          <table aria-label="Table with first half of case information" role="presentation" style="width: 100%;">
            <colgroup>
              <col style="width: 30%;">
              <col style="width: 70%;">
            </colgroup>
            <tbody>
              <tr>
                <td><strong>GAO Attorney Name</strong></td>
                <td>
                  <span [ngClass]="{ 'pending-entry color_warn': !partiesResponse.protestInfo.attorney_Name }">
                    {{ partiesResponse.protestInfo.attorney_Name || "pending" }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><span><strong>GAO Attorney Email</strong></span></td>
                <td><span>{{ partiesResponse.attorneyInfo?.email }}</span></td>
              </tr>
              <tr>
                <td><span><strong>GAO Attorney Phone</strong></span></td>
                <td><span>{{ partiesResponse.attorneyInfo?.phone_No }}</span></td>
              </tr>
              <tr>
                <td><span><strong>GAO Attorney Address</strong></span></td>
                <td>
                  <span *ngIf="partiesResponse.attorneyInfo">
                    <span>
                      {{ partiesResponse.attorneyInfo.address1 }}
                      <br/>
                    </span>
                    <span *ngIf="partiesResponse.attorneyInfo.address2">
                      {{ partiesResponse.attorneyInfo.address2 }}
                      <br/>
                    </span>
                    <span>
                      {{ partiesResponse.attorneyInfo.city }} {{ partiesResponse.attorneyInfo.state }} {{ partiesResponse.attorneyInfo.zip_Code }}
                    </span>
                    <span *ngIf="partiesResponse.attorneyInfo.country">
                      <br>
						          {{ partiesResponse.attorneyInfo.country }}
                    </span>
                  </span></td>
              </tr>
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
  </div>

  <div fxFill fxLayout="row wrap" fxLayoutAlign="space-between center" style="padding: 20px">
    <div>
      <a [href]="emailListOutlook"
         [hidden]="!(stateService.user.role_id == UserRole.GAO_Admin || stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor)" >
        Email All Parties</a>
    </div>
    <div>
      <button mat-raised-button color="primary"
              [hidden]="!(stateService.user.role_id == UserRole.GAO_Admin)"
              [disabled]="isIntervenorFormVisible || savingDetails.saving"
              (click)="onIntervenorAdd()">
        <mat-icon>add</mat-icon>
        <div *appSpinner="this.savingDetails.saving"></div>
        Add Intervenor
      </button>
    </div>
  </div>

  <div *ngIf="isIntervenorFormVisible">
    <app-add-intervenor [visible]="isIntervenorFormVisible" [a_No]="a_No" [emailsWithAccess]="emailListOutlook"
                        (onSubmit)="onIntervenorSubmit()" (onCancel)="onIntervenorCancel()">
    </app-add-intervenor>
  </div>

  <div *ngIf="!isIntervenorFormVisible" fxFill fxLayout="row wrap">
    <mat-card appearance="outlined" fxFill>
      <mat-card-content class="mat-elevation-z8" style="height: 100%" >
        <table aria-label="Table with party information" role="presentation" class="parties-table">
          <colgroup>
            <col style="width: 25%;">
            <col style="width: 75%;">
          </colgroup>
          <thead>
            <td><span><strong>Party</strong></span></td>
            <td><span><strong>Information</strong></span></td>
          </thead>
          <tbody>

            <!-- Protester parties  -->
            <tr>
              <td fxLayout="row">
                @if (stateService.userRole === UserRole.GAO_Admin) {
                  @if (caseTypeCtrl.editMode) {
                    <ng-container *ngTemplateOutlet="partyEdit"></ng-container>
                  } @else {
                    <ng-container *ngTemplateOutlet="partyRO"></ng-container>
                  }
                  <div fxFlex></div>
                  <app-edit-controls #caseTypeCtrl
                                     tooltipName="Party"
                                     [saveDisabled]="!(partyForm && partyForm.valid && partyForm.touched) || false"
                                     [value]="true"
                                     (onEdit)="onPartyEdit()"
                                     (onSave)="onPartyUpdate(caseTypeCtrl, partyForm, 'protester', partyFormData)">
                  </app-edit-controls>
                } @else {
                  <ng-container *ngTemplateOutlet="partyRO"></ng-container>
                }
              </td>
              <td>
                <app-parties-info partyType="P"
                                  [parties]="this"
                                  [protestInfo]="partiesResponse.protestInfo"
                                  [partyList]="partiesResponse.protester_parties_list"
                                  [savingDetails]="savingDetails">
                </app-parties-info>
              </td>
            </tr>

            <!-- intervenor parties -->
            @for (intervenorInfo of partiesResponse.listOfIntervenorParty; track intervenorInfo;let idx = $index) {
              <tr>
                <td fxLayout="row">
                  @if (stateService.userRole === UserRole.GAO_Admin) {
                    <div fxLayout="column">
                      <div fxLayout="row">
                        @if (intervenorCtrl.editMode) {
                          <ng-container *ngTemplateOutlet="intervenorEdit; context { $implicit: intervenorFormData[idx] }"></ng-container>
                        } @else {
                          <ng-container *ngTemplateOutlet="intervenorRO; context { $implicit: intervenorInfo[0] }"></ng-container>
                        }
                        <div fxFlex></div>
                        <app-edit-controls #intervenorCtrl
                                           tooltipName="Intervenor"
                                           [saveDisabled]="!(intervenorForm && intervenorForm.valid && intervenorForm.touched) || false"
                                           [value]="true"
                                           (onEdit)="onIntervenorEdit(intervenorInfo[0], intervenorFormData[idx])"
                                           (onSave)="onPartyUpdate(intervenorCtrl, intervenorForm, 'intervenor', intervenorFormData[idx])">
                        </app-edit-controls>
                      </div>
                      <div class="padded-party">
                        <button mat-raised-button color="warn" class="spinner-black"
                                [hidden]="!(stateService.userRole === UserRole.GAO_Admin)"
                                [disabled]="this.savingDetails.saving"
                                aria-label="Remove Intervenor"
                                (click)="removeIntervenorByUser(intervenorInfo[0])">
                          <mat-icon>close</mat-icon>
                          <div *appSpinner="this.savingDetails.saving"></div>
                          Remove Access
                        </button>
                      </div>
                    </div>
                  } @else {
                    <ng-container *ngTemplateOutlet="intervenorRO; context { $implicit: intervenorInfo[0] }"></ng-container>
                  }
                </td>
                <td>
                  <app-parties-info partyType="I"
                                    [intervenorCompanyName]="intervenorInfo[0].intervenor_Company_Name"
                                    [intervenorCompanyAddress]="intervenorInfo[0].intervenor_Company_Address"
                                    [parties]="this"
                                    [protestInfo]="partiesResponse.protestInfo"
                                    [partyList]="intervenorInfo"
                                    [savingDetails]="savingDetails">
                  </app-parties-info>
                </td>
              </tr>
            }

            <!-- orphan intervenor parties -->
            @for (orphanIntervenorInfo of partiesResponse.orphanIntComDetailList; track orphanIntervenorInfo; let idx = $index) {
              <tr>
                <td fxLayout="row">

                  <div>
                    @if (stateService.userRole === UserRole.GAO_Admin) {
                      <div fxLayout="column">
                        <div fxLayout="row">
                          @if (orphanIntervenorCtrl.editMode) {
                            <ng-container *ngTemplateOutlet="orphanIntervenorEdit; context { $implicit: orphanFormData[idx] }"></ng-container>
                          } @else {
                            <ng-container *ngTemplateOutlet="orphanIntervenorRO; context { $implicit: orphanIntervenorInfo }"></ng-container>
                          }
                          <div fxFlex></div>
                          <app-edit-controls #orphanIntervenorCtrl
                                             tooltipName="Orphan Intervenor"
                                             [saveDisabled]="!(orphanForm && orphanForm.valid && orphanForm.touched) || false"
                                             [value]="true"
                                             (onEdit)="onIntervenorEdit(orphanIntervenorInfo, orphanFormData[idx])"
                                             (onSave)="onPartyUpdate(orphanIntervenorCtrl, orphanForm, 'intervenor', orphanFormData[idx])">
                          </app-edit-controls>
                        </div>

                        <div class="padded-party">
                          <button mat-raised-button color="warn" class="spinner-black"
                                  [hidden]="!(stateService.userRole === UserRole.GAO_Admin)"
                                  [disabled]="this.savingDetails.saving"
                                  aria-label="Remove Orphan Intervenor"
                                  (click)="removeIntervenor(orphanIntervenorInfo)">
                            <mat-icon>close</mat-icon>
                            <div *appSpinner="this.savingDetails.saving"></div>
                            Remove Access
                          </button>
                        </div>
                      </div>
                    } @else {
                      <ng-container *ngTemplateOutlet="orphanIntervenorRO; context { $implicit:orphanIntervenorInfo }"></ng-container>
                    }

                  </div>
                </td>
                <td>
                  <app-parties-info partyType="I"
                                    isOrphanIntervenor="Y"
                                    [intervenorCompanyName]="orphanIntervenorInfo.companyName"
                                    [intervenorCompanyAddress]="orphanIntervenorInfo.companyAddress"
                                    [parties]="this"
                                    [protestInfo]="partiesResponse.protestInfo"
                                    [savingDetails]="savingDetails">
                  </app-parties-info>
                </td>
              </tr>
            }

            <!-- Agency parties -->
            <tr>
              <td fxLayout="column">
                <span><strong>{{ partiesResponse.protestInfo.agency_Name }}</strong></span>

                <div class="padded-party">
                  <button mat-raised-button color="primary" class="spinner-black"
                          [hidden]="!canPrimaryAgencyAddAgencyBtnBeDisplayed"
                          [disabled]="this.savingDetails.saving"
                          (click)="addPartiesToTheCase('Assign Agency Representative', 'A', savingDetails)">
                    <mat-icon>add</mat-icon>
                    <div *appSpinner="this.savingDetails.saving"></div>
                    Add Agency Representative
                  </button>
                </div>
              </td>
              <td>
                <app-parties-info partyType="A"
                                  [parties]="this"
                                  [protestInfo]="partiesResponse.protestInfo"
                                  [partyList]="partiesResponse.primary_agency_list"
                                  [savingDetails]="savingDetails">
                </app-parties-info>
              </td>
            </tr>

            <!-- Secondary Agency parties -->
            <tr>
              <td fxLayout="row">
                <span *ngIf="partiesResponse.secondary_agency_list && partiesResponse.secondary_agency_list.length > 0"><strong>{{ partiesResponse.secondary_agency_list[0].firm_Name }} (Secondary Agency)</strong></span>

                <div class="padded-party">
                  <button mat-raised-button color="primary" class="spinner-black"
                          [hidden]="!canSecAgencyAddAgencyBtnBeDisplayed"
                          [disabled]="this.savingDetails.saving"
                          (click)="addPartiesToTheCase('Assign Agency Representative', 'SA', savingDetails)">
                    <mat-icon>add</mat-icon>
                    <div *appSpinner="this.savingDetails.saving"></div>
                    Add Secondary Agency
                  </button>
                </div>
              </td>
              <td>
                <app-parties-info partyType="SA"
                                  [parties]="this"
                                  [protestInfo]="partiesResponse.protestInfo"
                                  [partyList]="partiesResponse.secondary_agency_list"
                                  [savingDetails]="savingDetails">
                </app-parties-info>
              </td>
            </tr>

          </tbody>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #partyRO>
  <div *ngIf="partiesResponse">
    <strong>PROTESTER ( {{ partiesResponse.protestInfo.company_Name }} )</strong>
    <div>
      <span>{{ partiesResponse.protestInfo.company_address1 }}</span>
      <br/>
      <span *ngIf="partiesResponse.protestInfo.company_address2">
        {{ partiesResponse.protestInfo.company_address2 }}
        <br/>
      </span>
      <span>
      {{ partiesResponse.protestInfo.company_City }} {{ partiesResponse.protestInfo.company_State }} {{ partiesResponse.protestInfo.company_Zipcode }}
        <br/>
        {{ partiesResponse.protestInfo.company_Country}}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #partyEdit>
  <form #partyForm="ngForm" *ngIf="partiesResponse && partyFormData" class="padded-party">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Company Name</mat-label>
      <input matInput name="companyName" [(ngModel)]="partyFormData.company_Name" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 1</mat-label>
      <input matInput name="address1" [(ngModel)]="partyFormData.company_address1" required
             appGmapAutocom (selectedPlace)="placeChanged($event, partyFormData)">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 2</mat-label>
      <input matInput name="address2" [(ngModel)]="partyFormData.company_address2">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>City</mat-label>
      <input matInput name="city" [(ngModel)]="partyFormData.company_City" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>State</mat-label>
      <input matInput name="state" [(ngModel)]="partyFormData.company_State" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Zip Code</mat-label>
      <input matInput name="zipCode" [(ngModel)]="partyFormData.company_Zipcode" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Country</mat-label>
      <input matInput name="country" [(ngModel)]="partyFormData.company_Country" required>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #intervenorRO let-intervenorInfo>
  <div>
    <span><strong>INTERVENOR ( {{ intervenorInfo.intervenor_Company_Name }} )</strong></span>

    <br>
    <span>{{ intervenorInfo.intervenor_Company_Address }}</span>
  </div>
</ng-template>

<ng-template #intervenorEdit let-partyFormData>
  <form #intervenorForm="ngForm" *ngIf="partiesResponse && partyFormData" class="padded-party">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Company Name</mat-label>
      <input matInput name="companyName" [(ngModel)]="partyFormData.company_Name" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 1</mat-label>
      <input matInput name="address1" [(ngModel)]="partyFormData.company_address1" required
             appGmapAutocom (selectedPlace)="placeChanged($event, partyFormData)">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 2</mat-label>
      <input matInput name="address2" [(ngModel)]="partyFormData.company_address2">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>City</mat-label>
      <input matInput name="city" [(ngModel)]="partyFormData.company_City" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>State</mat-label>
      <input matInput name="state" [(ngModel)]="partyFormData.company_State" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Zip Code</mat-label>
      <input matInput name="zipCode" [(ngModel)]="partyFormData.company_Zipcode" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Country</mat-label>
      <input matInput name="country" [(ngModel)]="partyFormData.company_Country" required>
    </mat-form-field>
  </form>
</ng-template>

<ng-template #orphanIntervenorRO let-orphanIntervenorInfo>
  <div>
    <span><strong>INTERVENOR ( {{ orphanIntervenorInfo.companyName }} )</strong></span>

    <br>
    <span>{{ orphanIntervenorInfo.companyAddress }}</span>
  </div>
</ng-template>

<ng-template #orphanIntervenorEdit let-orphanIntervenorInfo>
  <form #orphanForm="ngForm" *ngIf="partiesResponse && orphanIntervenorInfo" class="padded-party">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Company Name</mat-label>
      <input matInput name="companyName" [(ngModel)]="orphanIntervenorInfo.company_Name" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 1</mat-label>
      <input matInput name="address1" [(ngModel)]="orphanIntervenorInfo.company_address1" required
             appGmapAutocom (selectedPlace)="placeChanged($event, orphanIntervenorInfo)">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Address Line 2</mat-label>
      <input matInput name="address2" [(ngModel)]="orphanIntervenorInfo.company_address2">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>City</mat-label>
      <input matInput name="city" [(ngModel)]="orphanIntervenorInfo.company_City" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>State</mat-label>
      <input matInput name="state" [(ngModel)]="orphanIntervenorInfo.company_State" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Zip Code</mat-label>
      <input matInput name="zipCode" [(ngModel)]="orphanIntervenorInfo.company_Zipcode" required>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Country</mat-label>
      <input matInput name="country" [(ngModel)]="orphanIntervenorInfo.company_Country" required>
    </mat-form-field>
  </form>
</ng-template>
